import { mutate } from 'swr'

export function mutatePermissions() {
  mutate((key: string) => key.toLowerCase().startsWith('/permissions'))
}
